import {branch as branchHOC, renderNothing} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getBuild, getBuildType} from '../../../../../selectors'

import ViewThreadDumpButton from './ViewThreadDumpButton'
import type {OwnProps, StateProps, Props} from './ViewThreadDumpButton.types'

export default compose(
  connect((state: State, {buildId}: OwnProps): StateProps => {
    const build = getBuild(state, buildId)
    const buildType = getBuildType(state, build?.buildType)
    return {
      running: build?.state === 'running',
      composite: build?.composite,
      agentId: build?.agent?.id,
      projectId: buildType?.projectId,
      detachedFromAgent: build?.detachedFromAgent ?? false,
    }
  }),
  branchHOC(
    (props: Props) =>
      props.composite ||
      !props.running ||
      !props.agentId ||
      !props.projectId ||
      props.detachedFromAgent ||
      false,
    renderNothing,
  ),
)(ViewThreadDumpButton)
